// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2PXuk","inputWrap":"Table_inputWrap__2BIbo","col":"Table_col__1qxfJ","bmiTooltip":"Table_bmiTooltip__1pvAf"};